import React from 'react';
import BaseTableHead from '@material-ui/core/TableHead';

const TableHead = (props) => <BaseTableHead {...props} />;

export default TableHead;
